/* MoM free-game offer (Oct 2026). Progress bar, one-click add-ons, auto-add and swap of the
   free online escape room. Pairs with snippets/mom-free-game.liquid and the automatic
   "Buy X Get Y" discount in Shopify admin, which is what actually zeroes the price. */
(() => {
  if (customElements.get('mom-free-game')) return;

  const SS = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: (k) => { try { sessionStorage.removeItem(k); } catch (e) {} }
  };
  const K = { added: 'momfg_added', removed: 'momfg_removed', blocked: 'momfg_blocked', busy: 'momfg_busy', pending: 'momfg_pending', kept: 'momfg_kept' };
  const BUSY_MS = 15000;
  // A game's short name from its product title, by the snippet's rule ("Halloween Escape Room - Emmie" → "Emmie").
  const shortTitle = (t) => {
    const full = String(t == null ? '' : t);
    // Liquid's strip: ASCII whitespace and NUL only, so a name keeps what the card drew.
    const strip = (s) => s.replace(/^[\0\t\n\v\f\r ]+|[\0\t\n\v\f\r ]+$/g, '');
    const parts = full.split(' - ');
    while (parts.length > 1 && parts[parts.length - 1] === '') parts.pop();
    return strip(parts[parts.length - 1].split(' – ')[0]) || strip(full);
  };
  const esc =(s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const busy = () => { const b = SS.get(K.busy); return b && (Date.now() - parseInt(b, 10)) < BUSY_MS; };
  const BLOCK_MS = 10 * 60 * 1000;
  const blocked = () => { const b = SS.get(K.blocked); if (!b) return false; if (Date.now() - parseInt(b, 10) > BLOCK_MS) { SS.del(K.blocked); return false; } return true; };
  const block = () => SS.set(K.blocked, String(Date.now()));
  // The games the customer chose to keep at full price (variant ids). An older single id still reads.
  const keptList = () => {
    const raw = SS.get(K.kept);
    if (!raw) return [];
    try { const v = JSON.parse(raw); return Array.isArray(v) ? v.map(String) : [String(v)]; } catch (e) { return [raw]; }
  };
  const isKept = (v) => keptList().indexOf(String(v)) > -1;
  const keepGame = (v) => { const l = keptList(); if (l.indexOf(String(v)) === -1) l.push(String(v)); SS.set(K.kept, JSON.stringify(l)); };
  const unkeepGame = (v) => { const l = keptList().filter((x) => x !== String(v)); if (l.length) SS.set(K.kept, JSON.stringify(l)); else SS.del(K.kept); };
  const REQUEST_MS = 20000; // the longest this script waits for one of its own cart requests
  const timeout = (ms) => {
    if (window.AbortSignal && AbortSignal.timeout) return AbortSignal.timeout(ms);
    if (!window.AbortController) return undefined;
    // Older Safari: the same limit by hand (an abort reads as a timeout below).
    const c = new AbortController();
    setTimeout(() => c.abort(), ms);
    return c.signal;
  };
  const own = new Set();   // this script's adds and changes still on their way (the checkout guard waits for them)
  const ownBusy = () => {
    own.forEach((f) => { if (Date.now() - f.at > REQUEST_MS + 5000) own.delete(f); });
    return own.size > 0;
  };
  let ownDrawing = null;   // the card request whose basket is being drawn right now
  // Another card request still out (not stuck), besides this one and the one whose basket was being drawn when this one
  // started: an add-on's publish starts the auto-add, which comes after it.
  const ownOther = (flight) => Array.from(own).some((f) => f !== flight && f !== flight.from && Date.now() - f.at <= REQUEST_MS + 5000);
  let removing = null;    // line key of the game being removed, so two copies of the card never remove it twice
  let removeFailed = null; // line key whose automatic removal failed: the customer chooses instead of a retry loop
  // Copy for a game that is no longer free. The snippet's strings win if it ever supplies these keys.
  const PAID = {
    en: {
      paid: '{title} is no longer free and now costs {price}. Spend {amount} more and it’s free again, or remove it.',
      paid_final: '{title} is no longer free and now costs {price}. Keep it or remove it.',
      kept: 'You’re keeping {title} for {price}. Spend {amount} more and it’s free again.',
      kept_final: 'You’re keeping {title} for {price}.',
      keep: 'Keep it for {price}', remove: 'Remove game', paid_label: 'No longer free', game: 'This game',
      choose_first: 'Please keep or remove it before you check out.',
      updating: 'Updating your basket…',
      wait: 'Your basket is still updating. Please try again in a moment.',
      check: 'Your last change may not have gone through. Please check your basket, then check out again.',
      charged: '{title} is no longer free and costs {price}. Remove it from your basket, or tap Check out again to keep it.'
    },
    de: {
      paid: '{title} ist nicht mehr gratis und kostet jetzt {price}. Noch {amount}, dann ist das Spiel wieder gratis – oder Sie entfernen es.',
      paid_final: '{title} ist nicht mehr gratis und kostet jetzt {price}. Behalten oder entfernen Sie das Spiel.',
      kept: 'Sie behalten {title} für {price}. Noch {amount}, dann ist das Spiel wieder gratis.',
      kept_final: 'Sie behalten {title} für {price}.',
      keep: 'Für {price} behalten', remove: 'Spiel entfernen', paid_label: 'Nicht mehr gratis', game: 'Dieses Spiel',
      choose_first: 'Bitte behalten oder entfernen Sie das Spiel, bevor Sie zur Kasse gehen.',
      updating: 'Ihr Warenkorb wird aktualisiert …',
      wait: 'Ihr Warenkorb wird noch aktualisiert. Bitte versuchen Sie es gleich noch einmal.',
      check: 'Ihre letzte Änderung wurde möglicherweise nicht übernommen. Bitte prüfen Sie Ihren Warenkorb und gehen Sie dann erneut zur Kasse.',
      charged: '{title} ist nicht mehr gratis und kostet {price}. Entfernen Sie das Spiel aus dem Warenkorb oder gehen Sie erneut zur Kasse, um es zu behalten.'
    },
    fr: {
      paid: '{title} n’est plus offert et coûte désormais {price}. Ajoutez encore {amount} pour qu’il soit de nouveau offert, ou retirez-le.',
      paid_final: '{title} n’est plus offert et coûte désormais {price}. Gardez-le ou retirez-le.',
      kept: 'Vous gardez {title} pour {price}. Ajoutez encore {amount} pour qu’il soit de nouveau offert.',
      kept_final: 'Vous gardez {title} pour {price}.',
      keep: 'Le garder pour {price}', remove: 'Retirer le jeu', paid_label: 'Plus offert', game: 'Ce jeu',
      choose_first: 'Merci de garder ou de retirer le jeu avant de passer commande.',
      updating: 'Mise à jour de votre panier…',
      wait: 'Votre panier est en cours de mise à jour. Réessayez dans un instant.',
      check: 'Votre dernière modification n’a peut-être pas été prise en compte. Vérifiez votre panier, puis passez de nouveau commande.',
      charged: '{title} n’est plus offert et coûte {price}. Retirez-le de votre panier, ou passez de nouveau commande pour le garder.'
    },
    es: {
      paid: '{title} ya no es gratis y ahora cuesta {price}. Añade {amount} más para que vuelva a ser gratis, o quítalo.',
      paid_final: '{title} ya no es gratis y ahora cuesta {price}. Quédatelo o quítalo.',
      kept: 'Te quedas {title} por {price}. Añade {amount} más para que vuelva a ser gratis.',
      kept_final: 'Te quedas {title} por {price}.',
      keep: 'Quedármelo por {price}', remove: 'Quitar el juego', paid_label: 'Ya no es gratis', game: 'Este juego',
      choose_first: 'Antes de pagar, elige si te lo quedas o lo quitas.',
      updating: 'Actualizando tu cesta…',
      wait: 'Tu cesta todavía se está actualizando. Inténtalo de nuevo en un momento.',
      check: 'Es posible que tu último cambio no se haya guardado. Revisa tu cesta y vuelve a tramitar el pedido.',
      charged: '{title} ya no es gratis y cuesta {price}. Quítalo de tu cesta o vuelve a tramitar el pedido para quedártelo.'
    },
    it: {
      paid: '{title} non è più in omaggio e ora costa {price}. Aggiungi altri {amount} per riaverlo in omaggio, oppure rimuovilo.',
      paid_final: '{title} non è più in omaggio e ora costa {price}. Tienilo o rimuovilo.',
      kept: 'Tieni {title} a {price}. Aggiungi altri {amount} per riaverlo in omaggio.',
      kept_final: 'Tieni {title} a {price}.',
      keep: 'Tienilo a {price}', remove: 'Rimuovi il gioco', paid_label: 'Non più in omaggio', game: 'Questo gioco',
      choose_first: 'Prima di procedere all’acquisto, scegli se tenerlo o rimuoverlo.',
      updating: 'Aggiornamento del carrello…',
      wait: 'Il carrello si sta ancora aggiornando. Riprova tra un momento.',
      check: 'La tua ultima modifica potrebbe non essere stata salvata. Controlla il carrello, poi procedi di nuovo all’acquisto.',
      charged: '{title} non è più in omaggio e costa {price}. Rimuovilo dal carrello, oppure procedi di nuovo all’acquisto per tenerlo.'
    }
  };
  // One live region that outlives the cart's re-renders, so the change of price is announced.
  const announce = (html) => {
    let live = document.getElementById('mom-fg-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'mom-fg-live';
      live.className = 'sr-only';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const text = tmp.textContent;
    // A region filled in the same moment it appears is often not read out: fill it a beat later.
    live.textContent = '';
    setTimeout(() => { live.textContent = text; }, 150);
  };

  class MomFreeGame extends HTMLElement {
    connectedCallback() {
      if (this.dataset.state === 'empty') {
        [K.added, K.removed, K.blocked, K.busy, K.pending, K.kept].forEach(SS.del);
        return;
      }
      try {
        this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch (e) {
        this.hidden = true;
        // It can't ask about a charged game either: the cart's checkout asks instead (the guard), and the express buttons wait.
        if (this.dataset.state === 'paidgift') document.querySelectorAll('.additional-checkout-buttons').forEach((b) => { b.style.display = 'none'; });
        return;
      }
      this.strings = Object.assign({}, PAID[this.dataset.locale] || PAID.en, this.data.strings || {});
      this.gifts = (this.data.gifts || []).filter((g) => g && g.variant);
      this.addons = (this.data.addons || []).filter((a) => a && a.variant);
      // With the offer off the card only asks about a game we added earlier, so it needs no gift list.
      this.offerOff = this.dataset.offer === 'off';
      if ((!this.gifts.length && !this.offerOff) || !window.theme || !theme.routes) { this.hidden = true; return; }

      const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
      this.threshold = Math.round(parseInt(this.dataset.thresholdStore, 10) * rate);
      this.qualifying = parseInt(this.dataset.qualifying, 10) || 0;
      this.remaining = this.threshold - this.qualifying;
      this.saving = parseInt(this.dataset.saving || '0', 10) || 0;
      this.codeSaving = parseInt(this.dataset.codeSaving || '0', 10) || 0;
      this.codeTitle = this.dataset.codeTitle || '';
      this.giftValue = parseInt(this.dataset.giftValue || '0', 10) || 0;
      this.giftKey = this.dataset.giftKey || '';
      this.giftVariant = this.dataset.giftVariant || '';
      this.giftProduct = this.dataset.giftProduct || '';
      this.giftPrice = parseInt(this.dataset.giftPrice || '0', 10) || 0;
      this.sectionId = this.dataset.sectionId;

      this.el = {
        stamp: this.querySelector('.mom-fg__stamp'),
        text: this.querySelector('[data-fg-text]'),
        sub: this.querySelector('[data-fg-sub]'),
        bar: this.querySelector('[data-fg-bar]'),
        addons: this.querySelector('[data-fg-addons]'),
        actions: this.querySelector('[data-fg-actions]'),
        picker: this.querySelector('[data-fg-picker]')
      };
      this.el.stamp.textContent = this.t('stamp');
      this.addEventListener('click', this.onClick.bind(this));
      this.render();
    }

    /* ---------- helpers ---------- */
    t(key, vars) {
      const s = this.strings[key] || '';
      // One pass over the copy's own tokens: a value that holds "{price}" (a title, a code) stays as it is.
      return vars ? s.replace(/\{(\w+)\}/g, (m, k) => (Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : m)) : s;
    }
    // The game's name in bold for the copy under `key`, or "This game" (lower case mid-sentence) when it has none.
    named(title, key) {
      if (title) return '<strong>' + esc(title) + '</strong>';
      const word = esc(this.t('game') || PAID.en.game);
      // A capital where a sentence starts: the copy's start, after . ! ?, and in German after a colon (a full sentence follows).
      const before = (this.strings[key] || '').split('{title}')[0].replace(/\s+$/, '');
      const start = !before || /[.!?]$/.test(before) || (this.dataset.locale === 'de' && /:$/.test(before));
      return start ? word : word.charAt(0).toLowerCase() + word.slice(1);
    }
    money(cents) {
      const format = this.dataset.moneyFormat || '{{amount}}';
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, format);
      }
      return (cents / 100).toFixed(2);
    }
    get worth() { return Math.max.apply(null, this.gifts.map((g) => g.price || 0)); }
    get names() {
      const n = this.gifts.map((g) => g.name);
      if (n.length < 2) return n.join('');
      return n.slice(0, -1).join(', ') + ' ' + (this.t('or') || 'or') + ' ' + n[n.length - 1];
    }
    giftByVariant(v) { return (this.gifts || []).find((g) => String(g.variant) === String(v)); }
    giftByProduct(p) { return (this.gifts || []).find((g) => String(g.id) === String(p)); }
    show(el, on) { if (el) el.hidden = !on; }
    setBar(pct, on) {
      if (!this.el.bar) return;
      this.el.bar.hidden = !on;
      const i = this.el.bar.querySelector('i');
      if (i) requestAnimationFrame(() => i.style.setProperty('--fg-progress', Math.max(0, Math.min(100, pct)) + '%'));
    }

    /* ---------- states ---------- */
    render() {
      const state = this.dataset.state;
      // A Keep only ever applies to the charged game it was given for.
      if (state !== 'paidgift') SS.del(K.kept);
      // Offer ended with our game still in the basket: it is charged now, so ask; otherwise say nothing.
      if (this.offerOff) {
        if (state === 'paidgift') return this.renderPaid();
        // Still free: keep its stepper hidden, so it can't become a free and a charged copy.
        if (state === 'unlocked') this.markLine('free_label');
        this.hidden = true;
        return;
      }
      if (state === 'unlocked') return this.renderUnlocked();
      if (state === 'paidgift') return this.handlePaidGift();
      if (blocked()) { this.hidden = true; return; }
      if (this.remaining <= 0) {
        // Shopify keeps whichever saves more: if the basket's current product discounts already
        // beat the game's value, the game would not be granted, so promise nothing.
        if (this.giftValue && this.saving >= this.giftValue) { this.hidden = true; return; }
        if (busy()) { this.renderAdding(); setTimeout(() => this.isConnected && this.render(), 800); return; }
        if (SS.get(K.removed) || (SS.get(K.added) && !SS.get(K.pending))) return this.renderManual();
        // A typed code would be replaced by the game: let the customer choose, never swap it silently.
        if (this.codeSaving > 0 && !SS.get(K.pending)) return this.renderManual(true);
        return this.autoAdd();
      }
      SS.del(K.removed);
      this.renderProgress();
    }

    renderProgress() {
      this.hidden = false;
      this.classList.remove('is-unlocked');
      const pct = Math.round((this.qualifying / this.threshold) * 100);
      this.el.text.innerHTML = this.t('progress', { amount: '<strong>' + this.money(this.remaining) + '</strong>', worth: this.money(this.worth) });
      this.el.sub.innerHTML = esc(this.t('choose', { names: this.names }));
      this.show(this.el.sub, true);
      this.setBar(pct, true);
      this.show(this.el.actions, false);
      this.show(this.el.picker, false);
      this.renderAddons();
    }

    renderAddons() {
      if (!this.addons.length) { this.show(this.el.addons, false); return; }
      const sorted = this.addons.slice().sort((a, b) => {
        const ak = a.price >= this.remaining ? 0 : 1, bk = b.price >= this.remaining ? 0 : 1;
        return ak !== bk ? ak - bk : a.price - b.price;
      }).slice(0, 4);
      let html = '<p class="mom-fg__addons-title">' + esc(this.t('complete')) + '</p><ul class="mom-fg__addons-list" role="list">';
      sorted.forEach((a) => {
        const key = a.price >= this.remaining ? ' is-key' : '';
        html += '<li class="mom-fg__addon' + key + '">' +
          (a.image ? '<img class="mom-fg__addon-img" src="' + esc(a.image) + '" alt="" width="40" height="40" loading="lazy">' : '') +
          '<span class="mom-fg__addon-meta"><a class="mom-fg__addon-name" href="' + esc(a.url) + '">' + esc(a.name) + '</a><span class="mom-fg__addon-price">' + this.money(a.price) + '</span></span>' +
          '<button type="button" class="mom-fg__btn mom-fg__btn--add" data-fg-addon="' + esc(a.variant) + '">+ ' + esc(this.t('add')) + '</button></li>';
      });
      html += '</ul>';
      this.el.addons.innerHTML = html;
      this.show(this.el.addons, true);
    }

    renderAdding() {
      this.hidden = false;
      this.el.text.innerHTML = esc(this.t('adding'));
      this.show(this.el.sub, false);
      this.setBar(100, true);
      this.show(this.el.addons, false);
      this.show(this.el.actions, false);
      this.show(this.el.picker, false);
    }

    renderUnlocked() {
      this.hidden = false;
      this.classList.add('is-unlocked');
      const g = this.giftByVariant(this.giftVariant) || this.giftByProduct(this.giftProduct);
      const title = (g && g.name) || shortTitle(this.dataset.giftTitle);
      this.el.text.innerHTML = '<span class="mom-fg__tick" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="M4 10.5l4 4 8-9"/></svg></span>' + this.t('unlocked', { title: this.named(title, 'unlocked') });
      this.show(this.el.sub, false);
      this.setBar(100, false);
      this.show(this.el.addons, false);
      this.show(this.el.picker, false);
      if (this.gifts.length > 1) {
        this.el.actions.innerHTML = '<button type="button" class="mom-fg__btn mom-fg__btn--ghost" data-fg-change aria-expanded="false">' + esc(this.t('change')) + '</button>';
        this.show(this.el.actions, true);
      } else {
        this.show(this.el.actions, false);
      }
      SS.set(K.added, String(this.giftVariant || '1'));
      SS.del(K.pending);
      SS.del(K.busy);
      SS.del(K.kept);
      this.markLine('free_label');
    }

    renderManual(replacesCode) {
      this.hidden = false;
      this.classList.remove('is-unlocked');
      this.el.text.innerHTML = esc(this.t('manual')) + (replacesCode && this.codeTitle ? ' ' + esc(this.t('replaces', { code: this.codeTitle, saving: this.money(this.codeSaving) })) : '');
      this.show(this.el.sub, false);
      this.setBar(100, true);
      this.show(this.el.addons, false);
      this.el.actions.innerHTML = '<button type="button" class="mom-fg__btn mom-fg__btn--add" data-fg-change aria-expanded="false">' + esc(this.t('manual_btn')) + '</button>';
      this.show(this.el.actions, true);
      this.show(this.el.picker, false);
    }

    /* Below the threshold Shopify charges for our game and it stays in the basket. Charging for
       something the customer didn't pick needs their say-so, so until they keep or remove it the
       checkout waits (see the guard below) and the express buttons are hidden. */
    renderPaid() {
      this.hidden = false;
      this.classList.remove('is-unlocked');
      this.el.stamp.hidden = true;
      const kept = isKept(this.giftVariant);
      this.dataset.choice = kept ? 'kept' : 'pending';
      this.renderedAt = Date.now();
      const g = this.giftByVariant(this.giftVariant) || this.giftByProduct(this.giftProduct);
      const title = (g && g.name) || shortTitle(this.dataset.giftTitle);
      // A product code or bundle that already saves more would win again at the threshold: promise nothing.
      const value = g ? g.price : this.giftValue;
      const final = this.offerOff || this.remaining <= 0 || (value && this.saving >= value);
      const price = this.money(this.giftPrice);
      const key = (kept ? 'kept' : 'paid') + (final ? '_final' : '');
      this.el.text.innerHTML = this.t(key, { title: this.named(title, key), price: '<strong>' + price + '</strong>', amount: '<strong>' + this.money(this.remaining) + '</strong>' });
      this.show(this.el.sub, false);
      this.setBar(Math.round((this.qualifying / this.threshold) * 100), !final);
      // Remove comes first, so a double tap on Keep lands on empty space rather than on Remove.
      this.el.actions.innerHTML = '<button type="button" class="mom-fg__btn mom-fg__btn--ghost" data-fg-remove>' + esc(this.t('remove')) + '</button>' +
        (kept ? '' : '<button type="button" class="mom-fg__btn mom-fg__btn--ghost" data-fg-keep>' + esc(this.t('keep', { price })) + '</button>');
      this.show(this.el.actions, true);
      this.show(this.el.picker, false);
      if (final) this.show(this.el.addons, false);
      else this.renderAddons();
      // With two games we added in the basket the card can only show one: the express buttons stay hidden.
      const express = kept && !(parseInt(this.dataset.taggedCount || '0', 10) > 1);
      document.querySelectorAll('.additional-checkout-buttons').forEach((b) => { b.style.display = express ? '' : 'none'; });
      this.markLine('paid_label');
      if (!kept) announce(this.el.text.innerHTML);
    }

    /* The checkout was tapped before the customer kept or removed the game: say so, bring it into view.
       Focus reads the price line out; the live region adds only the request. */
    stopForChoice(silent) {
      this.el.sub.textContent = this.t('choose_first');
      this.show(this.el.sub, true);
      const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      this.el.text.setAttribute('tabindex', '-1');
      this.el.text.focus({ preventScroll: true });
      if (!silent) announce(esc(this.t('choose_first')));
    }

    renderPicker(excludeVariant) {
      let html = '<p class="mom-fg__picker-title">' + esc(this.t('pick')) + '</p><ul class="mom-fg__picker-list" role="list">';
      this.gifts.forEach((g) => {
        if (String(g.variant) === String(excludeVariant)) return;
        html += '<li><button type="button" class="mom-fg__tile" data-fg-pick="' + esc(g.variant) + '">' +
          (g.image ? '<img src="' + esc(g.image) + '" alt="" width="72" height="72" loading="lazy">' : '') +
          '<span class="mom-fg__tile-name">' + esc(g.name) + '</span><span class="mom-fg__tile-worth">' + esc(this.t('free_worth', { price: this.money(g.price) })) + '</span></button></li>';
      });
      html += '</ul>';
      this.el.picker.innerHTML = html;
      this.show(this.el.picker, true);
    }

    /* Hide the quantity stepper on our game's line so it can't be bumped to a paid second copy. */
    markLine(labelKey) {
      if (!this.giftKey) return;
      const input = document.getElementById('Quantity-' + this.sectionId + '-' + this.giftKey);
      const qi = input && input.closest('quantity-input');
      if (!qi || qi.hasAttribute('data-mom-fg-marked')) return;
      qi.setAttribute('data-mom-fg-marked', '');
      qi.hidden = true;
      const label = document.createElement('span');
      label.className = 'mom-fg__free-label';
      label.textContent = this.t(labelKey);
      qi.parentNode.insertBefore(label, qi);
      const row = qi.closest('li, tr');
      if (row) row.classList.add('mom-fg-line');
    }

    /* ---------- actions ---------- */
    onClick(e) {
      const change = e.target.closest('[data-fg-change]');
      if (change) {
        const open = this.el.picker.hidden;
        if (open) this.renderPicker(this.dataset.state === 'unlocked' ? this.giftVariant : null);
        else this.show(this.el.picker, false);
        change.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      const pick = e.target.closest('[data-fg-pick]');
      if (pick) { this.choose(pick.getAttribute('data-fg-pick')); return; }
      const addon = e.target.closest('[data-fg-addon]');
      if (addon) { this.addAddon(addon.getAttribute('data-fg-addon'), addon); return; }
      const keep = e.target.closest('[data-fg-keep]');
      const remove = e.target.closest('[data-fg-remove]');
      // Ignore the tail of a double tap that lands on a button drawn a moment ago.
      if ((keep || remove) && Date.now() - (this.renderedAt || 0) < 400) return;
      if (keep) {
        keepGame(this.giftVariant);
        this.renderPaid();
        // Focus the confirmation, not Remove: a held Enter must not undo the choice.
        this.el.text.setAttribute('tabindex', '-1');
        this.el.text.focus();
        return;
      }
      if (remove) { this.removeGift(remove); }
    }

    async removeGift(button) {
      if (removing === this.giftKey) return;
      button.disabled = true;
      this.dataset.choice = 'removing';
      removing = this.giftKey;
      const ok = await this.change(this.giftKey, 0, true);
      removing = null;
      if (ok) { unkeepGame(this.giftVariant); return; }
      // It didn't go, or was already gone: draw the basket as it is (or this card again, as it was).
      const drawn = await refreshCart().catch(() => false);
      if (!drawn && this.isConnected) this.renderPaid();
    }

    async autoAdd() {
      const pending = SS.get(K.pending);
      const gift = (pending && this.giftByVariant(pending)) || this.gifts[0];
      SS.set(K.busy, String(Date.now()));
      SS.del(K.removed);
      this.renderAdding();
      const ok = await this.add(gift.variant, true);
      SS.del(K.busy);
      if (!ok) { block(); this.hidden = true; }
    }

    /* The customer picked a game: swap (unlocked) or add (manual). */
    async choose(variant) {
      SS.set(K.busy, String(Date.now()));
      SS.set(K.pending, String(variant));
      SS.del(K.removed);
      this.renderAdding();
      if (this.dataset.state === 'unlocked' && this.giftKey) {
        const ok = await this.change(this.giftKey, 0, false);
        if (!ok) { SS.del(K.busy); return; }
      }
      const ok = await this.add(variant, true);
      SS.del(K.busy);
      if (!ok) { SS.del(K.pending); block(); this.hidden = true; }
    }

    async addAddon(variant, button) {
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      // One more of this product, on the customer's request: what they typed for it no longer applies.
      delete expect[String(variant)];
      await this.add(variant, false);
    }

    /* Our tagged line is in the cart but priced. Below the threshold that is the rule working: the
       game stays at full price and we say so, with the way back to free. At or above it Shopify
       didn't grant it (a code that can't combine won, or the offer is off): remove it, go quiet. */
    async handlePaidGift() {
      if (busy()) { this.dataset.choice = 'adding'; this.renderAdding(); setTimeout(() => this.isConnected && this.handlePaidGift(), 800); return; }
      // Below the threshold, or kept by the customer earlier: it stays, and the card says what it costs.
      if (this.remaining > 0 || isKept(this.giftVariant)) return this.renderPaid();
      // Our removal already failed once: leave the choice to the customer rather than retry on every redraw.
      if (removeFailed === this.giftKey) return this.renderPaid();
      this.dataset.choice = 'removing';
      this.hidden = true;
      // Another copy of this card is removing it already: look again once that has finished.
      if (removing === this.giftKey) { setTimeout(() => this.isConnected && this.handlePaidGift(), 600); return; }
      block();
      SS.del(K.added);
      SS.del(K.pending);
      removing = this.giftKey;
      const ok = await this.change(this.giftKey, 0, true);
      removing = null;
      if (ok) return;
      removeFailed = this.giftKey;
      const drawn = await refreshCart().catch(() => false);
      if (!drawn && this.isConnected) { this.hidden = false; this.renderPaid(); }
    }

    /* ---------- cart API (same pattern as the theme's product-form) ---------- */
    sections() {
      const s = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: s } }));
      return s;
    }
    // A refused request answers 4xx with `status`, or with only `errors` (a line that is gone): never draw that as a cart.
    async add(variant, asGift) {
      const item = { id: parseInt(variant, 10), quantity: 1 };
      if (asGift) item.properties = { _mom_free_game: '1' };
      const flight = { at: Date.now(), from: ownDrawing };
      own.add(flight);
      // A cart update or another card request still out may be answered, and drawn, on either side of this one. Looked
      // at once the redraw now running is done: the card drawn in it may have started this request before that update
      // was crossed off.
      Promise.resolve().then(() => { if (flights.length || ownOther(flight)) overlapped = true; });
      try {
        const body = JSON.stringify({ items: [item], sections: this.sections() });
        const res = await fetch(theme.routes.cart_add_url, Object.assign({}, theme.utils.fetchConfig(), { body, signal: timeout(REQUEST_MS) }));
        const parsed = await res.json();
        if (!res.ok || parsed.status || parsed.errors) { console.warn('[mom-free-game] add failed', parsed); return false; }
        await this.publish(parsed.sections, null, flight);
        return true;
      } catch (err) {
        // No answer to read: Shopify may have changed the basket without a redraw, so the next tap reads it.
        console.warn('[mom-free-game]', err);
        mustRead = true;
        holdExpress();
        return false;
      }
      finally { own.delete(flight); }
    }
    async change(key, quantity, doPublish) {
      const flight = { at: Date.now(), from: ownDrawing };
      own.add(flight);
      // As in add().
      Promise.resolve().then(() => { if (flights.length || ownOther(flight)) overlapped = true; });
      try {
        const body = JSON.stringify({ id: key, quantity, sections: doPublish ? this.sections() : [] });
        const res = await fetch(theme.routes.cart_change_url, Object.assign({}, theme.utils.fetchConfig(), { body, signal: timeout(REQUEST_MS) }));
        const parsed = await res.json();
        if (!res.ok || parsed.status || parsed.errors) { console.warn('[mom-free-game] change failed', parsed); return false; }
        if (doPublish) await this.publish(parsed.sections, parsed, flight);
        return true;
      } catch (err) {
        console.warn('[mom-free-game]', err);
        mustRead = true;
        holdExpress();
        return false;
      }
      finally { own.delete(flight); }
    }
    async publish(sections, cart, flight) {
      if (!cart) cart = await (await fetch(theme.routes.cart_url, theme.utils.fetchConfig('json', 'GET'))).json();
      cart.sections = sections || {};
      ownDrawing = flight || null;
      try { theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'mom-free-game', cart, momfgOwn: flight || true }); } finally { ownDrawing = null; }
    }
  }

  /* Checkout guard. A game that is no longer free stays in the basket at full price, and the
     customer keeps or removes it before checking out (renderPaid). The cart form posts its
     quantities natively, and that goes wrong while the basket is still changing: a quantity
     typed and submitted at once, an update still on its way from a part of the cart that has
     since been redrawn, or an edit lost on the way (the cart's 300 ms debounce sends only the
     last one, and Shopify can undo an edit when two updates overlap). So while the free game is
     in play and anything is moving, Check out waits until every update has landed, checks that
     the basket holds what the customer typed, stops on the card if the game is charged and not
     kept, and only then leaves, with a fresh form that carries no quantities. The guard never
     sends quantities itself: Shopify splits and re-keys lines as discounts change, so only the
     cart's own updates know which line an edit belongs to. */
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const FLIGHT_MS = 30000;  // a cart update that never answers stops counting after this
  const SETTLE_MS = 12000;  // the longest a tap on Check out waits for the basket
  let flights = [];         // the cart's own updates on their way: { line, at }
  let overlapped = false;   // two of them were out at once: Shopify may answer them, and the cart draw them, in either order
  let lastQtyChange = 0;
  let expect = {};          // variant id -> quantity typed for it (all its lines, our game's excluded), until a cart read at a tap shows it
  let lastCart = null;      // the last basket the cart drew
  let renders = 0;          // cart updates drawn, so a slow refresh never paints over a newer basket
  let guarding = false;
  let handedOff = false;
  let shown = null;         // the notice on screen: { key, vars }
  let guardErrors = 0;
  let failOpenAt = 0;       // after two failed checks in a row the guard stands aside for a minute
  let chargedSeen = null;   // { key, price, variant, at }: the customer was told this line is charged; a second tap keeps it
  let mustRead = false;     // the basket may differ from the page and couldn't be redrawn: the next tap reads it
  // The express buttons skip the card's question: while the page may not show the basket, hold them until a basket is drawn.
  const holdExpress = () => document.querySelectorAll('.additional-checkout-buttons').forEach((b) => { b.dataset.momfgHeld = '1'; b.style.display = 'none'; });
  const AGREE_MIN_MS = 1200; // a tap sooner than this after the 'charged' line can't have read it

  const isTimeout = (err) => !!err && (err.name === 'AbortError' || err.name === 'TimeoutError');
  const cartJson = async (ms) => {
    const res = await fetch(theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' }, signal: timeout(ms || 10000) });
    const cart = await res.json();
    // An error answer (a 429, say) is not a cart: never read it as "no charged game".
    if (!res.ok || !cart || !Array.isArray(cart.items)) throw new Error('cart.js ' + res.status);
    return cart;
  };
  const cartBusy = () => !!document.querySelector('cart-items.pointer-events-none');
  const tracked = () => { const C = customElements.get('cart-items'); return !!(C && C.prototype.momfgTracked); };
  // Nothing on its way: no cart update, none of this script's requests.
  const quiet = () => {
    const before = flights.length;
    flights = flights.filter((f) => Date.now() - f.at < FLIGHT_MS);
    // An update that never answered (hung, or its JSON body cut off) may still have changed the basket.
    if (flights.length < before) { mustRead = true; holdExpress(); }
    return !flights.length && !ownBusy();
  };
  const unsettled = () => !quiet() || !!busy() || Date.now() - lastQtyChange < 450 || (!tracked() && cartBusy());
  const pendingCard = (card) => !!(card && card.dataset.state === 'paidgift' && card.dataset.choice === 'pending' && !card.hidden && card.stopForChoice);
  // Our game's line in the form, when it is the one we added (an escape room the customer chose themselves is theirs).
  const giftKeyOf = (card) => (card && card.dataset.giftTagged !== '0' && card.dataset.giftKey) || '';
  // What the customer has typed for one product, over all its lines (our game's line excluded).
  const typedFor = (form, variant, giftKey) => {
    let n = 0;
    for (const el of form.elements) {
      if (el.name !== 'updates[]' || el.disabled || el.dataset.quantityVariantId !== variant || el.dataset.index === giftKey) continue;
      const q = parseInt(el.value, 10);
      if (isNaN(q)) return null;
      n += q;
    }
    return n;
  };
  const countIn = (cart, variant) => (cart.items || []).reduce((n, i) => n + (String(i.variant_id) === variant && !(i.properties && i.properties._mom_free_game === '1') ? i.quantity : 0), 0);
  const matches = (cart, want) => Object.keys(want).every((v) => countIn(cart, v) === want[v]);
  // The line the customer agreed to after the 'charged' notice: that line, at that price.
  const agreedTo = (i, agreed) => !!agreed && i.key === agreed.key && i.final_line_price === agreed.price;
  // A game we added that is charged and not kept.
  const chargedGift = (cart) => (cart.items || []).find((i) => i.properties && i.properties._mom_free_game === '1' && i.final_line_price > 0 && !isKept(i.variant_id));
  const releaseCheckout = () => document.querySelectorAll('button[name="checkout"][aria-busy]').forEach((b) => b.removeAttribute('aria-busy'));
  // An edit whose answer never came back leaves its number in the box and the cart untappable: put back what the cart drew.
  // Never while anything is moving (an answer on its way redraws the cart, and a number just typed is about to be sent),
  // and never in a box being typed in (the focused box is put back only if it holds the number it last sent).
  const restoreDrawn = () => {
    if (unsettled()) return;
    const form = document.getElementById('cart');
    const active = document.activeElement;
    if (form) for (const el of form.elements) if (el.name === 'updates[]' && (el !== active || el.value === el.dataset.momfgSent) && el.value !== el.defaultValue) { el.value = el.defaultValue; delete el.dataset.momfgSent; }
    document.querySelectorAll('cart-items.pointer-events-none').forEach((c) => c.classList.remove('pointer-events-none'));
    document.querySelectorAll('cart-items .loader[id^="Loader-"]').forEach((l) => { l.hidden = true; });
  };
  // The same checks as the cart's validateQuantity: a refused value is put back and never sent.
  const refused = (el) => {
    const q = parseInt(el.value, 10);
    return q < parseInt(el.getAttribute('data-min'), 10) || q > parseInt(el.max, 10) || q % parseInt(el.step, 10) !== 0;
  };

  // Every quantity the customer types (box, stepper or Enter) is remembered until a cart read at a tap shows it.
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || t.name !== 'updates[]' || !t.form || t.form.id !== 'cart') return;
    lastQtyChange = Date.now();
    chargedSeen = null; // a changed basket voids an earlier 'tap again to keep it'
    t.dataset.momfgSent = t.value;
    if (refused(t)) {
      // Never sent, and the cart puts the old number back: typing it again is a new change.
      delete t.dataset.momfgSent;
      // The cart puts the old value back but leaves the box invalid, and the browser then blocks every
      // tap on Check out until the number changes: clear that once the old value is back. Earlier typing stands.
      setTimeout(() => { if (t.isConnected && t.value === t.defaultValue) t.setCustomValidity(''); }, 1200);
      return;
    }
    const giftKey = giftKeyOf(document.querySelector('mom-free-game'));
    const v = t.dataset.quantityVariantId;
    if (!v || t.dataset.index === giftKey) return;
    const q = typedFor(t.form, v, giftKey);
    if (q === null) delete expect[v]; else expect[v] = q;
  }, true);
  // Enter in a field of the cart form submits it too (implicit submission, the Enter keypress's own default action):
  // note it, so that submit is never read as a tap on Check out. A click leaves this false wherever focus is.
  // A key press can reach the page as two events (keydown, then keypress) with the reset run between them, so both
  // note it; a line break committed as text (an IME, dictation) submits with no key event at all, so beforeinput does too.
  let enterInField = false;
  const enterKey = (e) => {
    const t = e.target;
    if (!t || t.tagName !== 'INPUT' || !t.form || t.form.id !== 'cart') return;
    const lineBreak = e.type === 'beforeinput'
      ? (e.data || '').indexOf('\n') > -1 || e.inputType === 'insertLineBreak' || e.inputType === 'insertParagraph'
      : e.key === 'Enter';
    if (!lineBreak) return;
    enterInField = true;
    setTimeout(() => { enterInField = false; }, 0);
  };
  document.addEventListener('keydown', enterKey, true);
  document.addEventListener('keypress', enterKey, true);
  document.addEventListener('beforeinput', enterKey, true);
  // The theme's Remove link takes one line out: what was typed for that product now excludes it.
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('a[is="cart-remove-button"]');
    const form = link && document.getElementById('cart');
    if (!form) return;
    chargedSeen = null; // removing a line (the game's included) is not keeping it, even if the request fails
    const giftKey = giftKeyOf(document.querySelector('mom-free-game'));
    const key = link.getAttribute('data-index');
    if (key === giftKey) return;
    const input = Array.from(form.elements).find((el) => el.name === 'updates[]' && el.dataset.index === key);
    const v = input && input.dataset.quantityVariantId;
    if (!v || !(v in expect)) return;
    const q = typedFor(form, v, giftKey);
    if (q === null) delete expect[v]; else expect[v] = Math.max(0, q - (parseInt(input.value, 10) || 0));
  }, true);
  // Count the cart's own updates out and back in, including those sent by a part of the cart that has since been redrawn.
  customElements.whenDefined('cart-items').then(() => {
    const CartItems = customElements.get('cart-items');
    if (CartItems.prototype.momfgTracked || !window.theme || !theme.pubsub) return;
    const update = CartItems.prototype.updateQuantity;
    CartItems.prototype.updateQuantity = function (line) {
      // Nothing else out: an earlier overlap has been drawn, or has already marked the page out of date.
      if (!flights.length && !ownBusy()) overlapped = false;
      const flight = { line: String(line), at: Date.now() };
      flights.push(flight);
      // The cart sends its request to /cart/change synchronously from here. Catch it, so that one which
      // fails without the cart reporting back (an HTML error page, a dropped connection) stops counting at once.
      const realFetch = window.fetch;
      let sent = null;
      window.fetch = function (resource) {
        const url = String((resource && resource.url) || resource || '');
        if (sent || url.indexOf(theme.routes.cart_change_url) === -1) return realFetch.apply(window, arguments);
        sent = realFetch.apply(window, arguments);
        return sent;
      };
      let threw = true;
      try {
        const result = update.apply(this, arguments);
        threw = false;
        return result;
      } finally {
        window.fetch = realFetch;
        const drop = () => { flights = flights.filter((f) => f !== flight); };
        // Failed before sending: nothing is on its way. Sent later, out of sight: it counts until it answers (or FLIGHT_MS).
        // An answer that can't be read may still have changed the basket: the next tap reads it before going anywhere.
        const lostAnswer = () => { drop(); mustRead = true; holdExpress(); };
        if (sent) sent.then((r) => { if (!/json|javascript/.test(r.headers.get('content-type') || '')) lostAnswer(); }, lostAnswer);
        else if (threw) drop();
        // One that never answers at all is expired here, so the express buttons are held even if nobody taps.
        if (sent) setTimeout(() => { if (flights.indexOf(flight) > -1) quiet(); }, FLIGHT_MS + 50);
        // Sent while another update, or a request of the card's, is still out: they may be answered in either order.
        if (sent && (flights.length > 1 || ownBusy())) overlapped = true;
      }
    };
    CartItems.prototype.momfgTracked = true;
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (ev) => {
      renders++;
      if (!ev || !ev.cart) return;
      let misordered = false;
      // The card's requests still out, besides the one whose basket this is. ownBusy() first drops one stuck for over
      // REQUEST_MS + 5 s: a card basket whose request was dropped so may be older than anything drawn since.
      const anyOwn = ownBusy();
      const mine = !!ev.momfgOwn && own.has(ev.momfgOwn);
      const others = anyOwn ? own.size - (mine ? 1 : 0) : 0;
      if (ev.source === 'cart-items') {
        const i = flights.findIndex((f) => f.line === String(ev.line));
        if (i > -1) flights.splice(i, 1);
        // The last answer in, of requests that were out together, may be the older basket; so may one that comes
        // after its update stopped counting (expired, or cleared on pageshow). A card request still out doesn't make it
        // the newest: its basket comes a round trip later at best, and never if it is refused or doesn't answer.
        misordered = i === -1 || (overlapped && !flights.length);
      } else if (ev.momfgOwn) misordered = !mine || (overlapped && !flights.length);
      // The overlap ends once nothing is out.
      if (!flights.length && !others) overlapped = false;
      // A changed basket voids an earlier "tap again to keep it".
      chargedSeen = null;
      // What was typed is crossed off only against a cart read at a tap (settle), never here: the last
      // answer to arrive is not always the last one Shopify wrote, and Shopify can undo an edit while another is out.
      if (ev.cart.items) lastCart = ev.cart;
      if (ev.cart.items && ev.cart.sections && Object.keys(ev.cart.sections).length) {
        // A drawn basket is the basket, unless it may be an older answer drawn last: then the next tap reads the cart.
        mustRead = misordered;
        // A drawn basket hands the express buttons back to the card (it hides them itself while it asks).
        setTimeout(() => {
          const c = document.querySelector('mom-free-game');
          const hold = !!c && ((c.dataset.state === 'paidgift' && (c.dataset.choice !== 'kept' || !c.el)) || parseInt(c.dataset.taggedCount || '0', 10) > 1);
          // Not while the page may be out of date (this basket, or a lost answer handled just after it was drawn):
          // hold the buttons this redraw brought until the next drawn basket.
          if (mustRead) holdExpress();
          else if (!hold) document.querySelectorAll('.additional-checkout-buttons[data-momfg-held]').forEach((b) => { delete b.dataset.momfgHeld; b.style.display = ''; });
        }, 0);
      } else if (misordered) {
        // Nothing drawn (refused), as the last answer of an overlap: an older basket may have been drawn before it.
        mustRead = true;
        holdExpress();
      }
      // The cart's redraw takes the notice with it: put it back while the guard is still waiting.
      if (guarding && shown) setTimeout(() => { if (guarding && shown && !document.getElementById('mom-fg-notice')) notice(shown.key, shown.vars, true); }, 0);
    });
  });

  // Re-render the cart in place from the server, rather than reloading into a page without this guard.
  const refreshCart = async (ms) => {
    const seen = renders;
    const ids = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: ids } }));
    if (!ids.length) return false;
    const [cart, sections] = await Promise.all([
      cartJson(ms),
      fetch(theme.routes.cart_url + '?sections=' + ids.join(','), { signal: timeout(ms || 10000) }).then(async (r) => {
        const json = await r.json();
        if (!r.ok) throw new Error('sections ' + r.status);
        return json;
      })
    ]);
    // Never draw an answer that isn't the cart (the cart would show itself as empty), nor over a newer
    // basket or one still changing.
    if (!sections || ids.some((id) => typeof sections[id] !== 'string')) return false;
    if (renders !== seen || unsettled()) return false;
    cart.sections = sections;
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'mom-free-game', cart });
    return true;
  };
  // A line above Check out, for when the guard holds the checkout without the card asking anything.
  const notice = (key, vars, silent) => {
    const button = document.querySelector('button[name="checkout"][form="cart"]');
    if (!button) return;
    const card = document.querySelector('mom-free-game');
    const strings = (card && card.strings) || PAID[(document.documentElement.lang || '').slice(0, 2)] || PAID.en;
    let text = strings[key] || PAID.en[key] || '';
    if (vars) text = text.replace(/\{(\w+)\}/g, (m, k) => (Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : m));
    let p = document.getElementById('mom-fg-notice');
    if (!p) {
      p = document.createElement('p');
      p.id = 'mom-fg-notice';
      p.className = 'mom-fg__notice text-center';
      p.style.cssText = 'margin:0;font-weight:600';
    }
    p.textContent = text;
    button.parentNode.insertBefore(p, button);
    shown = { key, vars };
    if (!silent) announce(esc(text));
  };
  const clearNotice = () => {
    shown = null;
    const p = document.getElementById('mom-fg-notice');
    if (p) p.remove();
  };
  const fmt = (cents) => {
    const card = document.querySelector('mom-free-game');
    return card && card.money ? card.money(cents) : (cents / 100).toFixed(2);
  };
  // Tell the customer a game we added is charged; a second tap, a moment later, keeps that line.
  const showCharged = (item) => {
    const card = document.querySelector('mom-free-game');
    const g = card && card.giftByVariant ? card.giftByVariant(item.variant_id) || card.giftByProduct(item.product_id) : null;
    // The card's own short name for its line (a card that couldn't start has no gift list), else the line's title.
    const own = card && card.dataset.giftVariant === String(item.variant_id) ? card.dataset.giftTitle : '';
    const title = (g && g.name) || shortTitle(own || item.product_title) || ((card && card.strings) || PAID[(document.documentElement.lang || '').slice(0, 2)] || PAID.en).game || PAID.en.game;
    notice('charged', { title, price: fmt(item.final_line_price) });
    chargedSeen = { key: item.key, price: item.final_line_price, variant: String(item.variant_id), at: Date.now() };
    // The page doesn't show this price, so until a basket is drawn every tap reads the cart (an Enter in a
    // box or a tap after the minute is not an agreement, and must not post this page natively).
    mustRead = true;
    // The page doesn't show this game's price (a stale page, or a card that couldn't start), so the express
    // buttons would skip the question: hold them until a basket is drawn again.
    holdExpress();
  };
  // The page's own line for the game, as drawn, when no basket has been drawn since the page loaded.
  const drawnLine = (card) => card && card.dataset.state === 'paidgift' && card.dataset.giftKey ? {
    items: [{
      key: card.dataset.giftKey,
      variant_id: card.dataset.giftVariant,
      product_title: card.dataset.giftTitle,
      final_line_price: parseInt(card.dataset.giftPrice || '0', 10) || 0,
      properties: { _mom_free_game: card.dataset.giftTagged === '0' ? '' : '1' }
    }]
  } : { items: [] };
  // Check out with everything the cart form holds except the quantities (note, attributes, the button's own name).
  const postFresh = (action, submitter) => {
    const form = document.getElementById('cart');
    const go = document.createElement('form');
    go.method = 'post';
    go.action = action;
    go.hidden = true;
    const field = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      go.appendChild(input);
    };
    if (form) {
      for (const el of form.elements) {
        if (!el.name || el.disabled || el.name === 'updates[]' || /^(submit|button|reset|file)$/.test(el.type)) continue;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
        field(el.name, el.value);
      }
    }
    if (submitter && submitter.name) field(submitter.name, submitter.value || '');
    document.body.appendChild(go);
    HTMLFormElement.prototype.submit.call(go);
  };
  // Wait for the basket to stop changing, then decide: go, stop (the card asks), lost (an edit didn't
  // land), busy (still changing after SETTLE_MS) or charged (the game is charged and the page can't ask).
  const settle = async (wantAtTap, agreed) => {
    const deadline = Date.now() + SETTLE_MS;
    const left = () => deadline - Date.now();
    const drawnAtTap = renders;
    let refreshed = false;
    for (;;) {
      while (unsettled()) {
        if (left() <= 0) return { outcome: 'busy' };
        await sleep(150);
      }
      // An agreement covers the basket it was given for: once the cart has been redrawn, ask again.
      if (agreed && renders !== drawnAtTap) agreed = null;
      if (left() <= 0) return { outcome: 'busy' };
      // Everything typed so far, including while this tap waited.
      const want = Object.assign({}, wantAtTap, expect);
      const asked = Date.now();
      let cart;
      try {
        cart = await cartJson(Math.max(1500, left()));
      } catch (err) {
        if (isTimeout(err)) return { outcome: 'busy' };
        throw err;
      }
      if (unsettled() || lastQtyChange > asked) continue;
      if (!matches(cart, want)) return { outcome: 'lost' };
      Object.keys(want).forEach((v) => { if (expect[v] === want[v]) delete expect[v]; });
      // The line agreed to is still there, at the same price, in the basket the customer saw: it is kept.
      if (agreed && cart.items.some((i) => agreedTo(i, agreed))) keepGame(agreed.variant);
      agreed = null;
      const charged = chargedGift(cart);
      if (!charged) return { outcome: 'go' };
      const card = document.querySelector('mom-free-game');
      if (pendingCard(card)) {
        card.stopForChoice();
        return { outcome: 'stop' };
      }
      // The page doesn't show the charged game (a stale page, a removal still settling): draw the basket, once.
      if (refreshed) return { outcome: 'charged', item: charged };
      refreshed = true;
      // Until a basket is drawn the page doesn't show this price: the next tap reads the cart, and express waits.
      mustRead = true;
      holdExpress();
      try {
        if (!(await refreshCart(Math.max(1500, left())))) await sleep(300);
      } catch (err) {
        // The read found the game charged and the page doesn't show it: the next tap reads again, and express waits for a redraw.
        mustRead = true;
        holdExpress();
        if (isTimeout(err)) return { outcome: 'busy' };
        console.warn('[mom-free-game] basket redraw failed', err);
        // The read worked and found the game charged; only the redraw failed. Ask about it here: counted towards
        // fail-open instead, its minute would let the next untouched tap post this page with the game in it.
        return { outcome: 'charged', item: charged };
      }
    }
  };
  // Back from checkout may restore this page from the browser's cache, as it was: start clean and redraw the basket.
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    guarding = false;
    handedOff = false;
    flights = [];
    chargedSeen = null;
    releaseCheckout();
    clearNotice();
    if (document.querySelector('mom-free-game')) refreshCart().catch(() => window.location.reload());
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'cart') return;
    if (!window.fetch || !window.theme || !theme.routes || !theme.pubsub || !theme.utils) return;
    if (guarding) {
      e.preventDefault();
      if (!handedOff) notice('updating');
      return;
    }
    const fg = document.querySelector('mom-free-game');
    if (!fg) return;
    quiet(); // expire updates that never answered before deciding (that sets mustRead)
    // Too soon after the 'charged' line to have read it (a double tap, an impatient tap): hold this one,
    // and count again from here, so keeping it takes a pause.
    if (chargedSeen && Date.now() - chargedSeen.at < AGREE_MIN_MS && shown && shown.key === 'charged') {
      e.preventDefault();
      chargedSeen.at = Date.now();
      setTimeout(releaseCheckout, 0);
      return;
    }
    // Told a moment ago that a game is charged, and tapped Check out again while those words are still on
    // screen and no card is asking: that is keeping that line, at that price. Anything else voids it,
    // Enter in a field of the cart form included (it submits the form too, but nobody tapped Check out).
    const agreed = chargedSeen && Date.now() - chargedSeen.at < 60000 && !pendingCard(fg) && !enterInField &&
      shown && shown.key === 'charged' && document.getElementById('mom-fg-notice') ? chargedSeen : null;
    chargedSeen = null;
    // In play: a free or charged game in the basket, or the card's own add still on its way.
    const inPlay = fg.dataset.state === 'unlocked' || fg.dataset.state === 'paidgift' || ownBusy() || busy();
    const giftKey = giftKeyOf(fg);
    // What the customer means to buy: everything typed that the cart doesn't show yet, even into a box it has since redrawn.
    const want = Object.assign({}, expect);
    for (const el of form.elements) {
      const v = el.name === 'updates[]' && !el.disabled && el.value !== el.defaultValue && el.dataset.index !== giftKey && el.dataset.quantityVariantId;
      if (v && !(v in want)) { const q = typedFor(form, v, giftKey); if (q !== null) want[v] = q; }
    }
    const submitter = e.submitter || null;
    const action = form.action;
    // After two failed checks in a row, stop reading the cart for a minute. Still stop on a card that is
    // asking, and still let the cart's own updates land and compare them with what was typed (no network).
    if (Date.now() - failOpenAt < 60000) {
      if (pendingCard(fg)) {
        e.preventDefault();
        clearNotice();
        fg.stopForChoice();
        setTimeout(releaseCheckout, 0);
        return;
      }
      // A charged game not kept that the card isn't asking about yet (being added, removed or drawn).
      const unsure = (c) => !!(c && c.el && c.dataset.state === 'paidgift' && c.dataset.choice !== 'kept');
      // What the card can't ask about: a second game we added, or a charged game on a card that couldn't start.
      const unseen = (c) => !!(c && (parseInt(c.dataset.taggedCount || '0', 10) > 1 || (!c.el && c.dataset.state === 'paidgift')));
      if (!inPlay || (!Object.keys(want).length && !unsettled() && !unsure(fg) && !unseen(fg))) return;
      e.preventDefault();
      guarding = true;
      handedOff = false;
      clearNotice();
      const drawnAtTap = renders;
      const slowOpen = setTimeout(() => notice('updating'), 2500);
      try {
        const cur = () => document.querySelector('mom-free-game');
        const end = Date.now() + SETTLE_MS;
        while ((unsettled() || (unsure(cur()) && !pendingCard(cur()))) && Date.now() < end) await sleep(150);
        clearTimeout(slowOpen);
        const card = cur();
        const typed = Object.assign({}, want, expect);
        if (pendingCard(card)) {
          clearNotice();
          card.stopForChoice();
        } else if (unsettled() || unsure(card)) {
          notice('wait');
        } else if (Object.keys(typed).length && (!lastCart || !matches(lastCart, typed))) {
          // The last basket drawn doesn't show what was typed: an edit didn't make it. Show what the cart holds.
          expect = {};
          mustRead = true;
          holdExpress();
          restoreDrawn();
          notice('check');
        } else {
          expect = {};
          // The last basket drawn (or, if none since the page loaded, the page's own line for the game).
          const seen = lastCart || (parseInt((card && card.dataset.taggedCount) || '0', 10) > 1 ? null : drawnLine(card));
          if (agreed && renders === drawnAtTap && seen && seen.items.some((i) => agreedTo(i, agreed))) keepGame(agreed.variant);
          const charged = unseen(card) && (seen ? chargedGift(seen) : 'unknown');
          if (charged === 'unknown') {
            notice('wait');
          } else if (charged) {
            showCharged(charged);
          } else {
            handedOff = true;
            setTimeout(() => { guarding = false; handedOff = false; clearNotice(); releaseCheckout(); }, 10000);
            postFresh(action, submitter);
          }
        }
      } finally {
        clearTimeout(slowOpen);
        // Decided within this tap (nothing to wait for): the button's own busy dots come after this, so release a tick later.
        if (!handedOff) { guarding = false; releaseCheckout(); setTimeout(releaseCheckout, 0); }
      }
      return;
    }
    if (!inPlay && !mustRead) return;
    // A charged game not yet kept (still choosing, being removed, or mid-render), or more than one game
    // we added (the card shows only one), is checked against the cart. So is a page the guard knows is out of date.
    const open = (fg.dataset.state === 'paidgift' && fg.dataset.choice !== 'kept') || parseInt(fg.dataset.taggedCount || '0', 10) > 1;
    if (!open && !agreed && !mustRead && !Object.keys(want).length && !unsettled()) return;
    e.preventDefault();
    guarding = true;
    handedOff = false;
    clearNotice();
    const slow = setTimeout(() => notice('updating'), 2500);
    try {
      const result = await settle(want, agreed);
      clearTimeout(slow);
      guardErrors = 0;
      if (result.outcome === 'go') {
        handedOff = true;
        // If the page outlives the hand-off (navigation cancelled), let the next tap through again.
        setTimeout(() => { guarding = false; handedOff = false; clearNotice(); releaseCheckout(); }, 10000);
        postFresh(action, submitter);
      } else if (result.outcome === 'lost') {
        // An edit didn't make it (lost on the way, or refused): show the basket as it really is.
        expect = {};
        clearNotice();
        // Until a redraw shows the real basket, the next tap reads it, even with nothing typed.
        mustRead = true;
        holdExpress();
        if (!(await refreshCart().catch(() => false))) restoreDrawn();
        const card = document.querySelector('mom-free-game');
        // The live region reads the 'check' line; focus on the card reads its price line.
        if (pendingCard(card)) card.stopForChoice(true);
        notice('check');
      } else if (result.outcome === 'busy') {
        notice('wait');
      } else if (result.outcome === 'charged') {
        showCharged(result.item);
      } else {
        clearNotice();
      }
    } catch (err) {
      console.warn('[mom-free-game] checkout guard', err);
      if (++guardErrors >= 2) { guardErrors = 0; failOpenAt = Date.now(); }
      notice('wait');
    } finally {
      clearTimeout(slow);
      if (!handedOff) { guarding = false; releaseCheckout(); }
    }
  }, true);

  customElements.define('mom-free-game', MomFreeGame);
  // The snippet holds the express buttons and the cart's checkout until this script is ready. A line it
  // showed for a tap made while waiting is out of date now (nothing here has shown one yet).
  const held = document.getElementById('mom-fg-notice');
  if (held) held.remove();
  document.documentElement.classList.add('momfg-ready');
})();
